import { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    Container,
    LastProductsLabel,
    SpaceAroundContainer,
    LastProductCard,
    StyledTitle,
    StyledTitleLight,
    IconContainer,
    StyledDescriptionIcon,
    BootstrapTooltip,
    StyledLabel,
    CarouselContainer,
    ScrollFab,
    ScrollFabContainer,
} from "./last-products-container.styled";
import amountToFixed from "@/helper/amountToFixed";
import { parseAmount } from "@/helper/parseAmount";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
const LastProductsContainer = ({ color, label, lastProducts, productSelectedHandler, comboSelectedHandler }) => {
    const containerRef = useRef(null);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);

    // Función que revisa si mostrar los botones
    const checkScroll = () => {
        const el = containerRef.current;
        if (!el) return;

        setShowLeft(el.scrollLeft > 0);
        setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
    };

    useEffect(() => {
        checkScroll();
        const el = containerRef.current;
        if (!el) return;

        el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        return () => {
            el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [lastProducts]);

    const scroll = (direction) => {
        if (!containerRef.current) return;

        const amount = direction === "left" ? -300 : 300;
        containerRef.current.scrollBy({ left: amount, behavior: "smooth" });
    };

    return (
        <Container borderColor={color}>
            <LastProductsLabel backgroundColor={color}>{label}</LastProductsLabel>
            <CarouselContainer>
                {showLeft && (
                    <ScrollFabContainer>
                        <ScrollFab color="primary" onClick={() => scroll("left")}>
                            <ChevronLeft style={{ fontSize: 35, color:"#b6b9bb" }} />
                        </ScrollFab>
                    </ScrollFabContainer>
                )}

                <SpaceAroundContainer ref={containerRef} spaceAround={lastProducts?.length <= 4}>
                    {lastProducts.map((product) => (
                        <LastProductCard
                            onClick={() =>
                                product.combo ? comboSelectedHandler(product) : productSelectedHandler(product)
                            }
                            key={product.id}
                        >
                            <BootstrapTooltip title={product.catalogName} placement="top">
                                <IconContainer>
                                    <StyledDescriptionIcon color={color} />
                                </IconContainer>
                            </BootstrapTooltip>
                            {product.combo && <StyledLabel>Combo</StyledLabel>}
                            <StyledTitle className="line-clamp-2">{product.name}</StyledTitle>
                            <StyledTitleLight>
                                {`RD$ ${amountToFixed(parseAmount(product.price), 2) || parseAmount(product.price)}`}
                            </StyledTitleLight>
                        </LastProductCard>
                    ))}
                </SpaceAroundContainer>
                {showRight && (
                    <ScrollFabContainer style={{ right: 0 }}>
                        <ScrollFab color="primary"  onClick={() => scroll("right")}>
                            <ChevronRight style={{ fontSize: 35, color:"#b6b9bb" }} />
                        </ScrollFab>
                    </ScrollFabContainer>
                )}
            </CarouselContainer>
        </Container>
    );
};

LastProductsContainer.propTypes = {
    color: PropTypes.string,
    label: PropTypes.string,
    lastProducts: PropTypes.array,
    productSelectedHandler: PropTypes.func,
};

export default LastProductsContainer;
